import React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '~/components/atoms/button/button';
import styles from './pager.module.scss';

interface IPager {
    loadMore: () => void;
}

const Pager: React.FC<IPager> = ({ loadMore }) => {
    return (
        <div className={styles.pager} data-testid="pager">
            <Button onclick={loadMore}>
                <FormattedMessage id="pager_more" defaultMessage="Načíst další výsledky" />
            </Button>
        </div>
    );
};

export default Pager;
